import { RangeFilterPayload } from '@shared/filters/entities/range-filter';
import { DateFilterWidget } from '@shared/magic-filter-bar/date-filter/entities/date-filter';
import { FilterSorter, PriceFilter, PriceRangeFilter, RangeFilterVm } from '@shared/filters/entities/fetch-filters.response';

export enum ActivitiesFilterTypes {
  SortBy = 'SortBy',
  PriceRange = 'PriceRange',
  ActivityNames = 'ActivityNames',
  ActivityType = 'ActivityType',
  ActivityDates = 'ActivityDates',
  Tags = 'Tags',
}

export enum ActivitiesFilterInputTypes {
  Range = 'range',
  Checkbox = 'checkbox',
  Input = 'input'
}

export type ActivitiesFiltersPayload = Readonly<{
  SessionToken: string;
  SearchId: string;
}>;

export type ActivitiesFiltersResponse = Readonly<{
  Filters: ActivitiesFilters;
}>;

export type ActivitiesFilters = Readonly<{
  ExtraPriceRanges: PriceRangeFilter[];
  ActivityDates: string[];
  Categories: ActivityFilter[];
  ActivityType: ActivityFilter[];
  ActivityNames: string[];
  MinPrice: number;
  MaxPrice: number;
  Tags: ActivityFilter[];
  Results: number;
}>;

export type ActivityFilter = Readonly<{
  Text: string;
  Count: number;
  ClassTag: string;
}>;

export type ActivitiesFiltersVm = Readonly<{
  ActivityDates: DateFilterWidget[];
  ActivityNames: string[];
  ActivityType: ActivityFilter[];
  PriceRange?: RangeFilterVm;
  Sorters: FilterSorter[];
  Tags: ActivityFilter[];
}>;

export type ActivitiesFilterVm = Readonly<{
  type: ActivitiesFilterTypes;
  filter: ActivitiesFilterInputTypes | undefined;
  value: ActivitiesFilterValueVm;
  order?: number;
}>;

export type ActivitiesFilterApplier = Readonly<{
  input?: ActivitiesFilterInputTypes;
  removable?: boolean;
  type: ActivitiesFilterTypes;
  value: ActivitiesFilterApplierValue;
}>;

export type ActivitiesFilterValueVm = RangeFilterVm | DateFilterWidget[];

export type ActivitiesFilterApplierValue = 
            string | number | string[] | number[] | ActivityCheckboxFilter[] | PriceFilter | RangeFilterPayload;

export interface ActivityCheckboxFilter {
  Text: string;
  Count: number;
}

export const ActivitiesFilterInputType = {
  [ActivitiesFilterTypes.PriceRange]: ActivitiesFilterInputTypes.Range,
  [ActivitiesFilterTypes.ActivityType]: ActivitiesFilterInputTypes.Checkbox,
};

export const ActivitiesFilterTitles = {
  [ActivitiesFilterTypes.SortBy]: 'PRODUCT_FILTERS.SORT_BY',
  [ActivitiesFilterTypes.PriceRange]: 'PRODUCT_FILTERS.PRICE',
  [ActivitiesFilterTypes.ActivityDates]: 'PRODUCT_FILTERS.DATE_FILTER.TITLE',
  [ActivitiesFilterTypes.ActivityType]: 'PRODUCT_FILTERS.ACTIVITY_FILTERS.ACTIVITY_TYPE',
  [ActivitiesFilterTypes.ActivityNames]: 'PRODUCT_FILTERS.ACTIVITY_FILTERS.ACTIVITY_NAME',
};

export const ActivitiesFilterBarTitles = {
  [ActivitiesFilterTypes.SortBy]: 'PRODUCT_FILTERS.SORT_BY',
  [ActivitiesFilterTypes.PriceRange]: 'PRODUCT_FILTERS.FILTER_BAR.PRICE',
  [ActivitiesFilterTypes.ActivityDates]: 'PRODUCT_FILTERS.DATE_FILTER.TITLE',
  [ActivitiesFilterTypes.ActivityType]: 'PRODUCT_FILTERS.ACTIVITY_FILTERS.ACTIVITY_TYPE',
  [ActivitiesFilterTypes.ActivityNames]: 'PRODUCT_FILTERS.ACTIVITY_FILTERS.ACTIVITY_NAME'
};

export const ActivitiesFilterOnFilterBar = [
  ActivitiesFilterTypes.PriceRange, 
  ActivitiesFilterTypes.ActivityDates
];

export const ACTIVITY_FILTERS_PLACEHOLDER = {
  [ActivitiesFilterTypes.ActivityNames]: 'PRODUCT_FILTERS.ACTIVITY_FILTERS.ACTIVITY_NAME_PLACEHOLDER'
};

export const FILTERS_PARAMETERS = [
  ActivitiesFilterTypes.ActivityNames,
  ActivitiesFilterTypes.ActivityType
];

